import React from 'react';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { API, APIRoutes } from '@utils/api';
import { GetServerSidePropsContext } from 'next';

import SingleOffer from '@components/SingleOffer';
import GlobalError from '@components/GlobalError';

type OfferPageProps = {
  offer: { name: string; slug: string; employerProfile: { description: string } };
  error: boolean;
};

const regex = /(<([^>]+)>)/gi;

function OfferPage({ offer, error }: OfferPageProps) {
  const { t } = useTranslation(['offers', 'common']);

  return (
    <>
      <Head>
        <title>{t('Offer')}</title>
        <meta property="og:title" content={offer.name} />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:secure_url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/images/lodz.png`} />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="279" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={offer.employerProfile?.description.replace(regex, '')} />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_PORTAL_URL}/oferty/${offer?.slug}`} />
      </Head>
      {error ? <GlobalError message={t('Page Not Found', { ns: 'common' })} /> : <SingleOffer offer={offer} />}
    </>
  );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
  const getTranslations = serverSideTranslations(locale, [
    'common',
    'homepage',
    'navbar',
    'footer',
    'offers',
    'employers',
    'bottomBanner',
  ]);
  try {
    const {
      data: { offer },
    } = await API.get(APIRoutes.offer(query.id));

    return {
      props: {
        ...(await getTranslations),
        offer,
        error: false,
      },
    };
  } catch (error) {
    return {
      props: {
        ...(await getTranslations),
        offer: {},
        error: true,
      },
    };
  }
}
export default OfferPage;
